import request from '@/utils/request'

let Courseware_classApi = {

  /*课件类别列表*/
  list(data) {
    return request._post('/shop/plus.courseware_class.Index/index', data);
},
/*添加课件类别*/
add(data) {
    return request._post('/shop/plus.courseware_class.Index/add', data);
},
/*修改课件类别*/
edit(data) {
    return request._post('/shop/plus.courseware_class.Index/edit', data);
},
/*删除课件类别*/
del(data) {
    return request._post('/shop/plus.courseware_class.Index/del', data);
},
/*课件类别详情*/
detail(data) {
  return request._post('/shop/plus.courseware_class.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.courseware_class.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.courseware_class.Setting/getSetting', data, errorback);
    },
}
export default Courseware_classApi;



// WEBPACK FOOTER //
// ./src/api/courseware_class.js